// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.warning-modal-icon {
  text-align: center;
  font-size: 38px;
  color: #5616ea;
  margin-bottom: 10px;
}

.warning-modal-title {
  margin: 0 0 12px;
  text-align: center;
  font-size: 1.25rem;
  color: #333;
}

.warning-modal-body {
  font-size: 0.95rem;
  line-height: 1.55;
  color: #555;
  margin-bottom: 20px;
}

.warning-modal-actions {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

/* Confirm mode (cancel + confirm) renders the buttons side by side,
   matching the action row in addBotModal. */
.warning-modal-actions.confirm {
  flex-direction: row;
  justify-content: flex-end;
}

.warning-modal-actions.confirm .warning-modal-btn {
  width: auto;
  min-width: 110px;
  padding: 10px 18px;
}

.warning-modal-btn {
  display: block;
  width: 100%;
  padding: 10px 0;
  border: none;
  border-radius: 8px;
  background-color: #5616ea;
  color: #fff;
  font-size: 15px;
  font-weight: 600;
  cursor: pointer;
  transition: background-color 0.2s ease;
}

.warning-modal-btn:hover {
  background-color: #4a14d6;
}

.warning-modal-btn:disabled {
  opacity: 0.55;
  cursor: not-allowed;
}

.warning-modal-btn.danger {
  background-color: #dc2626;
}

.warning-modal-btn.danger:hover {
  background-color: #b91c1c;
}

.warning-modal-btn.secondary {
  background-color: transparent;
  color: #5616ea;
  border: 1.5px solid #5616ea;
}

.warning-modal-btn.secondary:hover {
  background-color: #5616ea10;
}
`, "",{"version":3,"sources":["webpack://./src/components/WarningModal.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,eAAe;EACf,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;4CAC4C;AAC5C;EACE,mBAAmB;EACnB,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,WAAW;EACX,eAAe;EACf,YAAY;EACZ,kBAAkB;EAClB,yBAAyB;EACzB,WAAW;EACX,eAAe;EACf,gBAAgB;EAChB,eAAe;EACf,sCAAsC;AACxC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,6BAA6B;EAC7B,cAAc;EACd,2BAA2B;AAC7B;;AAEA;EACE,2BAA2B;AAC7B","sourcesContent":[".warning-modal-icon {\r\n  text-align: center;\r\n  font-size: 38px;\r\n  color: #5616ea;\r\n  margin-bottom: 10px;\r\n}\r\n\r\n.warning-modal-title {\r\n  margin: 0 0 12px;\r\n  text-align: center;\r\n  font-size: 1.25rem;\r\n  color: #333;\r\n}\r\n\r\n.warning-modal-body {\r\n  font-size: 0.95rem;\r\n  line-height: 1.55;\r\n  color: #555;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n.warning-modal-actions {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n/* Confirm mode (cancel + confirm) renders the buttons side by side,\r\n   matching the action row in addBotModal. */\r\n.warning-modal-actions.confirm {\r\n  flex-direction: row;\r\n  justify-content: flex-end;\r\n}\r\n\r\n.warning-modal-actions.confirm .warning-modal-btn {\r\n  width: auto;\r\n  min-width: 110px;\r\n  padding: 10px 18px;\r\n}\r\n\r\n.warning-modal-btn {\r\n  display: block;\r\n  width: 100%;\r\n  padding: 10px 0;\r\n  border: none;\r\n  border-radius: 8px;\r\n  background-color: #5616ea;\r\n  color: #fff;\r\n  font-size: 15px;\r\n  font-weight: 600;\r\n  cursor: pointer;\r\n  transition: background-color 0.2s ease;\r\n}\r\n\r\n.warning-modal-btn:hover {\r\n  background-color: #4a14d6;\r\n}\r\n\r\n.warning-modal-btn:disabled {\r\n  opacity: 0.55;\r\n  cursor: not-allowed;\r\n}\r\n\r\n.warning-modal-btn.danger {\r\n  background-color: #dc2626;\r\n}\r\n\r\n.warning-modal-btn.danger:hover {\r\n  background-color: #b91c1c;\r\n}\r\n\r\n.warning-modal-btn.secondary {\r\n  background-color: transparent;\r\n  color: #5616ea;\r\n  border: 1.5px solid #5616ea;\r\n}\r\n\r\n.warning-modal-btn.secondary:hover {\r\n  background-color: #5616ea10;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
